/** Client-side theme persistence / defaults — safe for SSR (`window` absent). */
export function saveDarkThemePreferenceToLocalStorage(pref: boolean): void {
  if (typeof window !== "undefined") {
    window.localStorage.setItem("isDarkTheme", JSON.stringify(pref));
  }
}

/** Used when creating the Redux store on the client so first paint matches saved or system preference. */
export function readInitialIsDark(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    const raw = window.localStorage.getItem("isDarkTheme");
    if (raw === null || raw === undefined || raw === "undefined") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
    return JSON.parse(raw) as boolean;
  } catch {
    return false;
  }
}
